package horcrux.common.utils

fun <A> A?.invert(): Unit? = if (this == null) Unit else null
